import * as THREE from 'three';
import { Material } from './Material';
import * as marietta3d from "../../../../marietta3d";
import { SMaterial } from "../../../../marietta3d/AutoGen/ModelParam_json"

/* tslint:disable:no-internal-module */

type materialParam = THREE.MeshLambertMaterialParameters | THREE.MeshPhongMaterialParameters | THREE.MeshStandardMaterialParameters | THREE.MeshBasicMaterialParameters;


export class MaterialSet {
    baseDir:string;

    constructor(baseDirectory?: string) {
      this.baseDir = baseDirectory;
      this.reset();
    }

    /*
     * 家関連のテクスチャ
     */
    // テクスチャ数の可変化.
    private roofTexes: THREE.Texture[];

    private hanaTexes: THREE.Texture[];

    private muneTexes: THREE.Texture[];

    private wallTexes: THREE.Texture[];

    private wallKosiTexes: THREE.Texture[];

    private floorTexes: THREE.Texture[];

    private stairTexes: THREE.Texture[];

    private tatamiTexes: THREE.Texture[];

    private clothTexes: THREE.Texture[];

    private entranceTexes: THREE.Texture[];

    private porchTexes: THREE.Texture[];

    private balconyTexes: THREE.Texture[];

    private baseTexes: THREE.Texture[];

    private siteTexes: THREE.Texture[];

    private roadTexes: THREE.Texture[];       // unused ----------------

    private lineTexes: THREE.Texture[];       // unused ----------------

    private makuitaTexes: THREE.Texture[];

    private timberTexes: THREE.Texture[];

    private madowakuTexes: THREE.Texture[];

    private girderTexes: THREE.Texture[];

    private habakiTexes: THREE.Texture[];

    private normalTexes: {};

    private outCubes: THREE.Texture[];

    private inCubes: THREE.Texture[];

    private tableClothTex: THREE.Texture;

    private newspaperTex: THREE.Texture;

    private hanaMaterials: Material[];

    private muneMaterials: Material[];

    private siteMaterials: Material[];

    private baseMaterials: Material[];

    private mejiMaterials: Material[];

    private sectionMaterials: Material[];

    private setbackMaterials: Material[];

    private roadMaterials: Material[];

    private lineMaterials: Material[];

    private makuitaMaterials: Material[];

    private timberMaterials: Material[];

    private madowakuMaterials: Material[];

    private glassMaterials: Material[];

    private metal: Material;

    private mirror: Material;

    private porch: Material;

    private entrance: Material;

    private floor: Material; // for stairs.

    private entDoors: Material[];

    private doorMaterials: Material[];

    private windowMaterials: Material[];

    private curtainMaterials: Material[];

    private garageMaterials: Material[];

    private tableCloth: Material;

    private ceramic: Material;

    private linen: Material;

    private newspaper: Material;

    private screen: Material;

    private metalWm : Material;

    private mirrorWm : Material;

    private screenWm : Material;

    private ceramicWm : Material;

    private tableClothWm : Material;

    private kasagiMaterials : Material[];

    private kasagiTexes: THREE.Texture[];

    private lightSettings: {};

    private shadowTexes: Material[];

    private shadowMaterials: Material[];

    private bathDoorMaterial:Material;

    public reset () {
      // clean up lists, others will be overwritten.
      this.roofTexes = [];
      this.hanaTexes = [];
      this.muneTexes = [];
      this.wallTexes = [];
      this.wallKosiTexes = [];
      this.floorTexes = [];
      this.stairTexes = [];
      this.tatamiTexes = [];
      this.clothTexes = [];
      this.porchTexes = [];
      this.balconyTexes = [];
      this.entranceTexes = [];
      this.baseTexes = [];
      this.siteTexes = [];
      this.roadTexes = [];
      this.lineTexes = [];
      this.makuitaTexes = [];
      this.timberTexes = [];
      this.madowakuTexes = [];
      this.girderTexes = [];
      this.habakiTexes = [];
      this.kasagiTexes = [];
      this.shadowTexes = [];
      this.normalTexes = {};

      this.outCubes = [];
      this.inCubes = [];
      this.glassMaterials = [];
      this.hanaMaterials = [];
      this.muneMaterials = [];
      this.siteMaterials = [];
      this.baseMaterials = [];
      this.mejiMaterials = [];
      this.sectionMaterials = [];
      this.setbackMaterials = [];
      this.roadMaterials = [];
      this.lineMaterials = [];
      this.makuitaMaterials = [];
      this.timberMaterials = [];
      this.madowakuMaterials = [];
      this.kasagiMaterials = [];

      this.entDoors = [];
      this.doorMaterials = [];
      this.bathDoorMaterial = undefined;
      this.windowMaterials = [];
      this.curtainMaterials = [];
      this.garageMaterials = [];
      this.lightSettings = {};
      this.shadowMaterials = [];
    }

    private addFloatParam (data: SMaterial, params: materialParam, propaty: string) {
      const value = data.GetParam(propaty);
      if ((value !== undefined) && (value !== '')) params[propaty] = parseFloat(value);
    }

    private addNameParam (data: SMaterial, params: materialParam) {
      const name = data.name;
      if ((name !== undefined) && (name !== '')) params.name = name;
    }

    private addCmbParam (data: SMaterial, params: materialParam, propaty: string) {
      const value = data.GetParam(propaty);
      if ((value !== undefined) && (value !== '')) {
        if (value === 'mix') params[propaty] = THREE.MixOperation;
        else if (value === 'multi') params[propaty] = THREE.MultiplyOperation;
      }
    }

    private addMapParam (data: SMaterial, params: materialParam, propaty: string) {
      const value = data.GetParam(propaty);
      if ((value !== undefined) && (value !== '')) {
        const [porchTexes0] = this.porchTexes;
        const [entranceTexes0] = this.entranceTexes;
        const [tatamiTexes0] = this.tatamiTexes;
        const [baseTexes0] = this.baseTexes;
        const [siteTexes0] = this.siteTexes;
        const [floorTexes0] = this.floorTexes;
        const [roadTexes] = this.roadTexes;
        const [lineTexes] = this.lineTexes;
        const [makuitaTexes] = this.makuitaTexes;
        const [timberTexes] = this.timberTexes;
        const [madowakuTexes] = this.madowakuTexes;
        const [kasagiTexes] = this.kasagiTexes;
        const [girderTexes] = this.girderTexes;
        const [habakiTexes0] = this.habakiTexes;

        if (value === 'porch') params[propaty] = porchTexes0;// this.porchTexes[0];
        else if (value === 'entrance') params[propaty] = entranceTexes0;// this.entranceTexes[0];
        else if (value === 'tatami') params[propaty] = tatamiTexes0;// this.tatamiTexes[0];
        else if (value === 'base') params[propaty] = baseTexes0;// this.baseTexes[0];
        else if (value === 'site') params[propaty] = siteTexes0;// this.siteTexes[0];
        else if (value === 'floor') params[propaty] = floorTexes0;// this.floorTexes[0];
        else if (value === 'girder') params[propaty] = girderTexes;// this.floorTexes[0];
        else if (value === 'habaki') params[propaty] = habakiTexes0;// this.floorTexes[0];
        else if (value === 'road') params[propaty] = roadTexes;// this.roadTexes[0];
        else if (value === 'line') params[propaty] = lineTexes;// this.lineTexes[0];
        else if (value === 'makuita') params[propaty] = makuitaTexes;// this.makuitaTexes[0];
        else if (value === 'timber') params[propaty] = timberTexes;// this.timberTexes[0];
        else if (value === 'madowaku') params[propaty] = madowakuTexes;// this.madowakuTexes[0];
        else if (value === 'kasagi') params[propaty] = kasagiTexes;// this.kasagiTexes[0];
        else if (value === 'tableCloth') params[propaty] = this.tableClothTex;
        else if (value === 'newspaper') params[propaty] = this.newspaperTex;
      }
    }

    private addSideParam (data: SMaterial, params: materialParam, propaty: string) {
      const value = data.GetParam(propaty);
      if ((value !== undefined) && (value !== '')) {
        if (value === 'double') params[propaty] = THREE.DoubleSide;
      }
    }

    private addHexParam (data: SMaterial, params: materialParam, propaty: string) {
      const value = data.GetParam(propaty);
      if ((value !== undefined) && (value !== '')) params[propaty] = parseInt(value, 16);
    }

    private addBoolParam (data: SMaterial, params: materialParam, propaty: string) {
      const value = data.GetParam(propaty);
      if ((value !== undefined) && (value !== '')) params[propaty] = (value === 'true');
    }

    private addEnvParam (data: SMaterial, params: materialParam, propaty: string) {
      const value = data.GetParam(propaty);
      if ((value !== undefined) && (value !== '')) params[propaty] = (value === 'inside' ? this.inCubes[0] : this.outCubes[0]);
    }

    private createLightSetting = (data) => {
      const lig:any = {};
      lig.name = data.name;
      lig.type = data.GetParam('type');
      lig.color = data.GetParam('color');
      lig.power = data.GetParam('power');
      lig.distance = data.GetParam('distance');
      lig.decay = data.GetParam('decay');
      lig.intensity = data.GetParam('intensity');
      return lig;
    }

    private createMaterial (data: SMaterial) {

        //共通パラメーター
        const setMaterialParameter= (materialParam) => {
            this.addNameParam(data, materialParam);
            this.addHexParam(data, materialParam, 'color');             //
            this.addFloatParam(data, materialParam, 'opacity');          //
            this.addBoolParam(data, materialParam, 'transparent');     //
            this.addMapParam(data, materialParam, 'map');              //
            this.addEnvParam(data, materialParam, 'envMap');           //
        }

      const type = data.GetParam('mtype');
      if (type === 'Lambert') {
        const params: THREE.MeshLambertMaterialParameters = {};
        setMaterialParameter(params);
        // this.addNameParam(data, params);
        // this.addHexParam(data, params, 'color');             //
        // this.addFloatParam(data, params, 'shininess'); // doesn't exist.
        this.addFloatParam(data, params, 'reflectivity');
        // this.addFloatParam(data, params, 'opacity');          //
        // this.addBoolParam(data, params, 'transparent');     //
        this.addCmbParam(data, params, 'combine');
        // this.addMapParam(data, params, 'map');              //
        // this.addEnvParam(data, params, 'envMap');           //

        // const mat: THREE.MeshLambertMaterial = new THREE.MeshLambertMaterial(params);
        const mat = new THREE.MeshStandardMaterial(params);
        // (mat as any).title = params.title;
        return mat;
      }
      if (type === 'Phong') {
        const params: THREE.MeshPhongMaterialParameters = {};
        setMaterialParameter(params);
        // this.addNameParam(data, params);
        // this.addHexParam(data, params, 'color');            //
        this.addHexParam(data, params, 'specular');
        // this.addBoolParam(data,params, 'metal'); // doesn't exist.
        this.addFloatParam(data, params, 'shininess');
        this.addFloatParam(data, params, 'reflectivity');
        // this.addFloatParam(data, params, 'opacity');            //
        // this.addBoolParam(data, params, 'transparent');     //
        this.addCmbParam(data, params, 'combine');
        this.addSideParam(data, params, 'side');
        // this.addMapParam(data, params, 'map');          //
        // this.addEnvParam(data, params, 'envMap');       //

        // const mat = new THREE.MeshPhongMaterial(params);
        const mat = new THREE.MeshStandardMaterial(params);
        // (mat as any).title = params.title;
        return mat;
      }
      if (type === 'Standard') {
        const params: THREE.MeshStandardMaterialParameters = {};
        setMaterialParameter(params);
        // this.addNameParam(data, params);
        // this.addHexParam(data, params, 'color');            //
        this.addHexParam(data, params, 'specular');
        this.addBoolParam(data, params, 'metal');
        this.addFloatParam(data, params, 'shininess');
        // this.addFloatParam(data, params, 'reflectivity'); // doesn't exist.
        // this.addFloatParam(data, params, 'opacity');        //
        this.addFloatParam(data, params, 'roughness');
        // this.addBoolParam(data, params, 'transparent');     //
        // this.addCmbParam(data, params, 'combine'); // doesn't exist.
        this.addSideParam(data, params, 'side');
        // this.addMapParam(data, params, 'map');          //
        // this.addEnvParam(data, params, 'envMap');       //

        const mat = new THREE.MeshStandardMaterial(params);
        // (mat as any).title = params.title;
        return mat;
      }

      const params: THREE.MeshBasicMaterialParameters = {};
      setMaterialParameter(params);
    //   this.addNameParam(data, params);
    //   this.addHexParam(data, params, 'color');          //
      this.addFloatParam(data, params, 'reflectivity');
    //   this.addFloatParam(data, params, 'opacity');      //
    //   this.addBoolParam(data, params, 'transparent');       //
      this.addCmbParam(data, params, 'combine');
    //   this.addMapParam(data, params, 'map');        //
    //   this.addEnvParam(data, params, 'envMap');     //

      // const mat:any = new THREE.MeshBasicMaterial(params);
      const mat = new THREE.MeshStandardMaterial(params);
    //   mat.title = params.title;
      return mat;
    }

    private setTexture(materialData: SMaterial): void {
        const mType = materialData.GetParam('type');
        const tex = this.createTexture(materialData);

        if (mType.match(/roof/)) this.roofTexes.push(tex);
        if (mType.match(/hana/)) this.hanaTexes.push(tex);
        if (mType.match(/mune/)) this.muneTexes.push(tex);
        if (mType.match(/wall/)) this.wallTexes.push(tex);
        if (mType.match(/kosi/)) this.wallKosiTexes.push(tex);
        if (mType.match(/floor/)) this.floorTexes.push(tex);
        if (mType.match(/stair/)) this.stairTexes.push(tex);
        if (mType.match(/balcony/)) this.balconyTexes.push(tex);
        if (mType.match(/site/)) this.siteTexes.push(tex);
        if (mType.match(/base/)) this.baseTexes.push(tex);
        if (mType.match(/road/)) this.roadTexes.push(tex);
        if (mType.match(/line/)) this.lineTexes.push(tex);
        if (mType.match(/makuita/)) this.makuitaTexes.push(tex);
        if (mType.match(/girder/)) this.girderTexes.push(tex);
        if (mType.match(/habaki/)) this.habakiTexes.push(tex);
        if (mType.match(/timber/)) this.timberTexes.push(tex);
        if (mType.match(/madowaku/)) this.madowakuTexes.push(tex);
        if (mType.match(/kasagi/)) this.kasagiTexes.push(tex);
        if (mType.match(/porch/)) this.porchTexes.push(tex);
        if (mType.match(/entrance/)) this.entranceTexes.push(tex);
        if (mType.match(/cloth/) && !mType.match(/tablecloth/)) this.clothTexes.push(tex);
        if (mType.match(/tablecloth/)) this.tableClothTex = tex;
        if (mType.match(/tatami/)) this.tatamiTexes.push(tex);
        if (mType.match(/newspaper/)) this.newspaperTex = tex;
        if (mType.match(/normal/)) {
            const keys = tex.name.split(',');
            keys.forEach((key: any) => { this.normalTexes[key] = tex; });
        }
        if (mType.match(/shadow/)) this.shadowTexes[tex.name] = tex;
    }

     /*
        マテリアルのプロパティ
    */
    private setMaterial(materialData: SMaterial): void {
        const mat = <Material><unknown>this.createMaterial(materialData);
        const mType = materialData.GetParam('type');

        if (mType.match(/hana/)) this.hanaMaterials.push(mat);
        if (mType.match(/mune/)) this.muneMaterials.push(mat);
        if (mType.match(/ent_body/)) this.entDoors.push(mat);
        if (mType.match(/curtain/)) this.curtainMaterials.push(mat);
        if (mType.match(/sash/)) this.windowMaterials.push(mat);
        if (mType.match(/door_body/)) this.doorMaterials.push(mat);
        if (mType.match(/bath_door/)) this.bathDoorMaterial = mat;
        if (mType.match(/shutter/)) this.garageMaterials.push(mat);
        if (mType.match(/meji/)) this.mejiMaterials.push(mat);
        if (mType.match(/site/)) this.siteMaterials.push(mat);
        if (mType.match(/base/)) this.baseMaterials.push(mat);
        if (mType.match(/road/)) this.roadMaterials.push(mat);
        if (mType.match(/line/)) this.lineMaterials.push(mat);
        if (mType.match(/makuita/)) this.makuitaMaterials.push(mat);
        if (mType.match(/timber/)) this.timberMaterials.push(mat);
        if (mType.match(/madowaku/)) this.madowakuMaterials.push(mat);
        if (mType.match(/kasagi/)) this.kasagiMaterials.push(mat);
        if (mType.match(/section/)) this.sectionMaterials.push(mat);
        if (mType.match(/setback/)) this.setbackMaterials.push(mat);
        if (mType.match(/porch/)) this.porch = mat;
        if (mType.match(/glass/)) this.glassMaterials.push(mat);
        if (mType.match(/newspaper/)) this.newspaper = mat;

        // 以下　wmが付くマテリアルはホワイトモデル
        if (mType.match(/metal/)) {
            this.metal = mat;
            this.metalWm = this.metal.clone();
            this.metalWm.transparent = true;
            this.metalWm.opacity = 0.60;
        }
        if (mType.match(/mirror/)) {
            this.mirror = mat;
            this.mirrorWm = this.mirror.clone();
            this.mirrorWm.transparent = true;
            this.mirrorWm.opacity = 0.60;
        }
        if (mType.match(/screen/)) {
            this.screen = mat;
            this.screenWm = this.screen.clone();
            this.screenWm.transparent = true;
            this.screenWm.opacity = 0.60;
        }
        if (mType.match(/ceramic/)) {
            this.ceramic = mat;
            this.ceramicWm = this.ceramic.clone();
            this.ceramicWm.transparent = true;
            this.ceramicWm.opacity = 0.60;
        }
        if (mType.match(/tablecloth/)) {
            this.tableCloth = mat;
            this.tableClothWm = this.tableCloth.clone();
            this.tableClothWm.transparent = true;
            this.tableClothWm.opacity = 0.60;
        }
        if (mType.match(/shadow/)) this.shadowMaterials[mat.name] = mat;
    }

    private setCubeMap(materialData: SMaterial): void {
        const cube = this.cubeMap(materialData.GetParam('cube'));
        const mType = materialData.GetParam('type');
        if (mType.match(/out/)) this.outCubes.push(cube);
        if (mType.match(/in/)) this.inCubes.push(cube);
    }

    /*
      マテリアルデータの取得
    */
    public getMaterialData (plan: marietta3d.AutoGen.ConstructionModel): void {
      const l = plan.MaterialList.length;

      for (let i = 0; i < l; i += 1) {
        const mData = plan.MaterialList[i];
        const mType = mData.GetParam('type');
        /*
             * テクスチャ
            */
        if (mType.match(/tex:/)) {
            this.setTexture(mData);
        } else if (mType.match(/cube:/)) {
            this.setCubeMap(mData);
        } else if (mType.match(/mat:/)) {
            /*
                マテリアルのプロパティ
            */
            this.setMaterial(mData);
        } else if (mType.match(/lig:/)) {
          const lig = this.createLightSetting(mData);
          this.lightSettings[lig.type] = lig;
        }
      }
    }

    /*
    データからテクスチャを作成
    */
    private createTexture (mdata: SMaterial): THREE.Texture {
      const { name } = mdata;

      const url = mdata.GetParam('image');
      const textureURL = `${this.baseDir}${url}`;

      const texLoader = new THREE.TextureLoader();
      texLoader.crossOrigin = '';
      const texture = texLoader.load(textureURL);
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texture.encoding = THREE.sRGBEncoding;

      const texturPlaneSize = 15000; // 15m * 15m plane.
      const pitch = mdata.GetParam('pitch');
      const wrapPitch = pitch.split('x');
      texture.repeat.set(texturPlaneSize / parseFloat(wrapPitch[0]), texturPlaneSize / parseFloat(wrapPitch[1])); // 15m * 15mの平面でテクスチャを何回繰り返すか

      texture.userData.url = textureURL;

      const thumbnail = mdata.GetParam('thumbnail');
      texture.userData.thumbnail = `${this.baseDir}${thumbnail}`;
    //   texture.url = texPath;
      texture.name = name;

      const title = mdata.GetParam('title');
      if (title === undefined) texture.userData.title = texture.name;
      texture.userData.title = title;
    //   if (title === undefined) texture.title = texture.name;
    //   texture.title = title;

      const category = mdata.GetParam('category');
      if (category === undefined) texture.userData.category = category;
      texture.userData.category = category;
      
      const scaleX = mdata.GetParam('scaleX');
      if (scaleX !== undefined) texture.userData.scaleX = scaleX;

      const scaleY = mdata.GetParam('scaleY');
      if (scaleY !== undefined) texture.userData.scaleY = scaleY;

      const shininess = mdata.GetParam('shininess');
      if (shininess !== undefined) texture.userData.shininess = shininess;
    //   if (scaleX !== undefined) texture.scaleX = scaleX;
    //   if (scaleY !== undefined) texture.scaleY = scaleY;
    //   if (shininess !== undefined) texture.shininess = shininess;
      return texture;
    }

    /*
    データからテクスチャキューブを作成
    */
    private cubeMap (dir: string) {
      // const urls: string[] = [];
      // urls.push(`${this.baseDir + dir}/posx.png`);
      // urls.push(`${this.baseDir + dir}/negx.png`);
      // urls.push(`${this.baseDir + dir}/posy.png`);
      // urls.push(`${this.baseDir + dir}/negy.png`);
      // urls.push(`${this.baseDir + dir}/posz.png`);
      // urls.push(`${this.baseDir + dir}/negz.png`);
      // const cubemap: THREE.Texture = THREE.ImageUtils.loadTextureCube(urls);
      const cubemap: THREE.Texture = new THREE.CubeTextureLoader()
      .setPath( `${this.baseDir + dir}/` )
      .load( [
        'posx.png',
        'negx.png',
        'posy.png',
        'negy.png',
        'posz.png',
        'negz.png'
      ]);

      cubemap.format = THREE.RGBAFormat;
      return cubemap;
    }

    /*
    public
    ( Access: MaterialSet.materials().key )
    */
    public materials() {
      const obj = {
        roofTexes: this.roofTexes,
        hanaTexes: this.hanaTexes,
        muneTexes: this.muneTexes,
        wallTexes: this.wallTexes,
        wallKosiTexes: this.wallKosiTexes,
        floorTexes: this.floorTexes,
        stairTexes: this.stairTexes,
        tatamiTexes: this.tatamiTexes,
        clothTexes: this.clothTexes,
        porchTexes: this.porchTexes,
        balconyTexes: this.balconyTexes,
        entranceTexes: this.entranceTexes,
        baseTexes: this.baseTexes,
        siteTexes: this.siteTexes,
        roadTexes: this.roadTexes,
        lineTexes: this.lineTexes,
        timberTexes: this.timberTexes,
        makuitaTexes: this.makuitaTexes,
        madowakuTexes: this.madowakuTexes,
        kasagiTexes: this.kasagiTexes,
        normalTexes: this.normalTexes,
        shadowTexes: this.shadowTexes,

        outCubes: this.outCubes,
        inCubes: this.inCubes,
        tableClothTex: this.tableClothTex,
        newspaperTex: this.newspaperTex,
        hanaMaterials: this.hanaMaterials,
        muneMaterials: this.muneMaterials,
        baseMaterials: this.baseMaterials,
        siteMaterials: this.siteMaterials,
        mejiMaterials: this.mejiMaterials,
        sectionMaterials: this.sectionMaterials,

        setbackMaterials: this.setbackMaterials,
        roadMaterials: this.roadMaterials,
        lineMaterials: this.lineMaterials,
        timberMaterials: this.timberMaterials,
        makuitaMaterials: this.makuitaMaterials,
        madowakuMaterials: this.madowakuMaterials,
        kasagiMaterials: this.kasagiMaterials,

        glassMaterials: this.glassMaterials,
        metal: this.metal,
        mirror: this.mirror,
        porch: this.porch,
        entrance: this.entrance,
        floor: this.floor, // for stairs.

        entDoors: this.entDoors,
        doorMaterials: this.doorMaterials,
        windowMaterials: this.windowMaterials,
        curtainMaterials: this.curtainMaterials,
        garageMaterials: this.garageMaterials,
        shadowMaterials: this.shadowMaterials,
        bathDoorMaterial: this.bathDoorMaterial,

        tableCloth: this.tableCloth,
        ceramic: this.ceramic,
        linen: this.linen,
        newspaper: this.newspaper,
        screen: this.screen,
        metal_wm: this.metalWm,
        mirror_wm: this.mirrorWm,
        screen_wm: this.screenWm,
        ceramic_wm: this.ceramicWm,
        tableCloth_wm: this.tableClothWm,
        lightSettings: this.lightSettings,

        habakiTexes: this.habakiTexes,
        girderTexes: this.girderTexes,
      };
      return obj;
    }
}
